/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NeeDocumentsDataDocuments model module.
 * @module model/NeeDocumentsDataDocuments
 * @version 1.0.0
 */
class NeeDocumentsDataDocuments {
    /**
     * Constructs a new <code>NeeDocumentsDataDocuments</code>.
     * @alias module:model/NeeDocumentsDataDocuments
     */
    constructor() { 
        
        NeeDocumentsDataDocuments.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NeeDocumentsDataDocuments</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NeeDocumentsDataDocuments} obj Optional instance to populate.
     * @return {module:model/NeeDocumentsDataDocuments} The populated <code>NeeDocumentsDataDocuments</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NeeDocumentsDataDocuments();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
NeeDocumentsDataDocuments.prototype['id'] = undefined;

/**
 * @member {String} name
 */
NeeDocumentsDataDocuments.prototype['name'] = undefined;






export default NeeDocumentsDataDocuments;

